// @flow

import React from 'react';
import {
  CardContainer, CardDate, CardImage, CardImageContainer, CardTitle, TextContainer,
} from './style';


type Props = {
  celebrationTitle: string,
  startDate: string,
  endDate: string,
  displayDate: string,
  filterValue: string,
  celebrationImage: string,
  handleFilterClick: Function,
  data: Object,
};

export const FeaturedCelebrationCard = ({
  celebrationTitle,
  startDate,
  endDate,
  filterValue,
  celebrationImage,
  handleFilterClick,
  displayDate,
  data,
}: Props) => {
  const handleClick = () => handleFilterClick(
    celebrationTitle,
    startDate,
    endDate,
    filterValue,
    displayDate,
    data,
  );

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <CardContainer
      role='button'
      tabIndex={0}
      aria-label={`${celebrationTitle}, ${displayDate}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
    <CardImageContainer>
      <CardImage src={celebrationImage} alt={celebrationTitle} />
    </CardImageContainer>
    <TextContainer>
      <CardTitle>{celebrationTitle}</CardTitle>
      <CardDate>{displayDate}</CardDate>
    </TextContainer>
  </CardContainer>
  );
};
